import React from "react";
import { Inbox } from "lucide-react";

export default function EmptyState({
  title = "Sin datos",
  description = "No hay información para mostrar.",
  icon: Icon = Inbox,
  action = null, // { label: "Reintentar", onClick: fn }
}) {
  return (
    <div className="p-8 text-center text-white/70">
      <Icon className="w-10 h-10 mx-auto mb-2 opacity-70" />
      <div className="text-sm font-semibold text-white/80">{title}</div>
      <div className="text-xs opacity-70 mt-1">{description}</div>

      {action?.label && typeof action?.onClick === "function" && (
        <button
          onClick={action.onClick}
          className="mt-4 px-3 py-2 rounded-md border border-white/15 hover:bg-white/10 text-xs"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
